<template>
  <div id="assets-maindiv" class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
<!--      <div class="spinner-div"><b-spinner class="spinner" label="Busy" v-if="loading"></b-spinner></div>-->
      <b-link :to="previousPageLink" style="text-decoration: none;color: #2c3e50" v-if="!loading && previousPageLink != null">
        <div class="breadcrumb">
          <b-icon class="backimage" aria-label="back" icon="chevron-compact-left"></b-icon>
          {{ previousPageTitle }}
        </div>
      </b-link>
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-section">
          {{ $t('beni') }}
        </div>
        <div class="area-top-subtitle" v-if="parseInt(idCollection) !== 0 && collectionName != null">
          {{ collectionName }}
        </div>
        <div class="area-top-links" v-if="parseInt(idCollection) !== 0 && collectionName != null && (collection.sito_web != null || collection.email != null)">
          <a :href="collection.sito_web" target="_blank" v-if="!$utilities.isEmpty(collection.sito_web)">{{ $t('sito_web') }}</a>
          <a :href="'mailto:' + collection.email" v-if="collection.email != null">{{ $t('contatti') }}</a>
        </div>
      </div>
      <div class="area-description-container">
        <div class="area-description">
          <div v-html="collectionDescription" v-if="!loading"></div>
          <b-button id="button-more" pill variant="info" class="p-1 mb-4 button-color" v-if="!loading && !$utilities.isEmpty(collectionDescriptionMore)" v-b-toggle.collapse-more >{{ $t(buttonMoreTranslationKey) }}</b-button>
          <b-collapse id="collapse-more" class="mt-2" @shown="buttonMoreTranslationKey = 'readless'" @hidden="buttonMoreTranslationKey = 'readmore'">
            <p class="card-text text-left" v-html="collectionDescriptionMore"></p>
          </b-collapse>
          <div v-if="!loading && collectionTeaching != null">
            <b-button id="assets-unimi-button" block v-b-toggle.accordion pill variant="info" class="p-1 button-color" >{{ $t("offerta_formativa") }}</b-button>
            <b-collapse id="accordion" accordion="accordion-offerta-formativa">
              <b-card-body style="background-color: #EEEEEE;border-radius: 25px;margin-top: 1px">
                <div id="assets-unimi-div" v-html="collectionTeaching"></div>
              </b-card-body>
            </b-collapse>
          </div>
        </div>
        <div class="youtubevideo-container" v-if="!loading && !$utilities.isEmpty(collectionVideo) && this.$i18n.locale == 'it'">
          <iframe class="youtubevideo" :src="collectionVideo" title="Cà Granda" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <!-- Area ricerca -->
      <div class="area-search" v-if="!loading">
        <b-icon :icon="(this.sort === 1) ? 'sort-alpha-down' : 'sort-alpha-down-alt'" aria-label="sort" style="margin-right: 15px; cursor: pointer" class="h2 pt-2" @click="setSort()"></b-icon>
        <b-input-group>
          <b-input-group-prepend style="height: 40px" is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input v-model="searchFilter.searchAssets" style="height: 40px" type="search" :placeholder="$t('filtro_semplice')"></b-form-input>
        </b-input-group>
      </div>
      <!-- Area cards -->
      <div class="assets-cards">
        <div class="spinner-div"><b-spinner class="spinner" label="Busy" v-if="loading"></b-spinner></div>
        <b-card
            class="assets-card"
            no-body
            border-variant="white"
            v-for="(asset, index) in filteredAssets"
            :key="asset.id"
        >
          <div @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
            <b-link :to="{ name: 'asset', query: { ids: filteredAssetsIds }, params: {idAsset: asset.id, previousPageLink: previousPageLink, previousPageTitle: previousPageTitle}}"
                    style="text-decoration: none;color: #2c3e50;width: 100%">
              <b-card-img-lazy class="results-card-image" :class="{'selected': isCardSelected(index)}" :src="asset.image" :alt="$utilities.getTranslation(asset, 'nome', $i18n.locale)" top></b-card-img-lazy>
            </b-link>
          </div>
          <b-card-text class="results-card-num-results" style="margin-left: 10px">
            <p class="mb-0">{{ asset.numImages + " " + $tc("immagini-n", asset.numImages) }}</p>
          </b-card-text>
          <b-link :to="{ name: 'asset', query: { ids: filteredAssetsIds }, params: {idAsset: asset.id, previousPageLink: previousPageLink, previousPageTitle: previousPageTitle}}"
                  style="text-decoration: none;color: #2c3e50" @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
            <b-card-text class="results-card-title" style="margin-left: 10px; margin-bottom: 0">
              {{ $utilities.getTranslation(asset, "nome", $i18n.locale) }}
            </b-card-text>
            <b-card-text class="results-card-subtitle" style="margin-left: 10px" v-if="$utilities.getTranslation(asset, 'nome2', $i18n.locale) != null">
              {{ $utilities.getTranslation(asset, "nome2", $i18n.locale) }}
            </b-card-text>
          </b-link>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Assets',
  data: function() {
    return {
      buttonMoreTranslationKey: "readmore",
      showOverlay: false,
      structure: null,
      collection: null,
      assets: [],
      loading: true,
      searchFilter: {
        searchAssets: '', // Stringa di ricerca
        area: '',
        mediaType: 'all',
      },
    };
  },
  created() {
    this.fetchAssets()
  },
  computed: {
    filteredAssets() {
      let assets = this.assets;
      // Filtro per struttura
      assets = assets.filter(asset => {
        return this.$utilities.getTranslation(asset, "nome", this.$i18n.locale).toLowerCase().includes(this.searchFilter.searchAssets.toLowerCase());
      });
      return assets.sort((a, b) => parseInt(a.order) - parseInt(b.order));
    },
    filteredAssetsIds() {
      const assets = this.assets;
      return assets.map((a) => a.id).join();
    },
    collectionName() {
      return this.$utilities.getTranslation(this.collection, "nome", this.$i18n.locale);
    },
    collectionTeaching() {
      return this.$utilities.getTranslation(this.collection, "offerta_formativa", this.$i18n.locale);
    },
    collectionDescription() {
      return this.$utilities.getTranslation(this.collection, "descrizione", this.$i18n.locale);
    },
    collectionDescriptionMore() {
      return this.$utilities.getTranslation(this.collection, "descrizione2", this.$i18n.locale);
    },
    collectionVideo() {
      if (this.collection == null)
        return null;
      else
        return this.collection.videos;
    },
    idCollection() {
      return this.$route.params.idCollection;
    },
    previousPageLink() {
      if (this.$route.params.previousPageLink != null) {
        this.$session.set("previousPageLink", this.$route.params.previousPageLink);
        return this.$route.params.previousPageLink;
      } else {
        if (this.$session.exists("previousPageLink"))
          return this.$session.get("previousPageLink");
        else
          return null;
      }
    },
    previousPageTitle() {
      if (this.$route.params.previousPageTitle != null) {
        this.$session.set("previousPageTitle", this.$route.params.previousPageTitle);
        return this.$route.params.previousPageTitle;
      } else {
        if (this.$session.exists("previousPageTitle"))
          return this.$session.get("previousPageTitle");
        else
          return null;
      }
    }
  },
  watch: {
    "$route.params.idCollection"() {
      this.fetchAssets();
    },
  },
  methods: {
    async fetchAssets() {
      // Collezione
      const collectionsData = await this.$client.getItems("collezioni", {fields: ["id", "id_dipartimento", "email", "sito_web", "videos", "traduzioni.*"], filter: {
          id: {
            eq: this.idCollection
          }}});
      if (collectionsData.data.length > 0)
        this.collection = collectionsData.data[0];

      // Struttura
      if (this.collection != null && this.collection.id_dipartimento != null) {
        const structuresData = await this.$client.getItems("dipartimenti", {
          fields: ["*", "traduzioni.*"], filter: {
            id: {
              eq: this.collection.id_dipartimento.id
            }
          }
        });
        if (structuresData.data.length > 0)
          this.structure = structuresData.data[0];
      }

      const assetsData = await this.$client.getItems("beni", {fields: ["id", "id_collezione", "vetrina", "traduzioni.*"], limit: -1, filter: {
          id_collezione: {
            eq: this.idCollection
          },
          vetrina: {
            eq: 1
          }
        }
      });
      let assets = assetsData.data;
      let listOfAssetIds = "";
      for (let asset in assets) {
        listOfAssetIds += assets[asset].id + ",";
      }

      const joinsData = await this.$client.getItems("join_beni_directus_files", {fields: ["*"], limit: -1, filter: {
          id_beni: {
            in: listOfAssetIds
          }}});
      let joins = joinsData.data;
      let listOfIdDirectusFiles = "";
      for (let join in joins) {
        listOfIdDirectusFiles += joins[join].id_directus_files + ",";
      }

      const filesData = await this.$client.getFiles({limit: -1, filter: {
        id: {
          in: listOfIdDirectusFiles
        }}});
      let files = filesData.data;

      for (let asset in assets) {
        assets[asset].order = Number.MAX_VALUE;
        assets[asset].image = null;
        assets[asset].numImages = 0;
        for (let join in joins) {
          if (assets[asset].id === joins[join].id_beni) {
            assets[asset].numImages++;
            const imageId = "" + joins[join].id_directus_files;
            for (let file in files) {
              if (files[file].id != imageId)
                continue;
              // Immagini
              let assetUrl = this.$client.getAssetUrl(files[file].private_hash, {key: "directus-large-contain"});
              // Ordine di visualizzazione delle immagini (se esiste)
              if (files[file].metadata != null && files[file].metadata.order != null) {
                if (assets[asset].order > files[file].metadata.order) { // si prende l'immagine con order minimo
                  assets[asset].order = files[file].metadata.order;
                  assets[asset].image = assetUrl;
                }
              }
              if (assets[asset].image == null) { // se non è specificato order assegna comunque l'immagine
                assets[asset].image = assetUrl;
              }
            }
          }
        }
      }
      this.assets = assets.sort((a, b) => parseInt(a.order) - parseInt(b.order));
      this.loading = false;
    },
    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex
    },
    isCardSelected(cardIndex) {
      return this.selectedCard === cardIndex
    },
  }
}
</script>

<style>
</style>
